import { OlCommission } from '../../../lib/types/models/ol/commission/ol-commission'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getOlCommission(id: number) {
  return restApiClient
    .url(constructApiUrl(API.ols.getOlCommission.url, { id }))
    .get<OlCommission>()
}
